import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Linkedin: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21" 
            viewBox="0 0 21 21"
            fill="none"
        >
            <path d="M4.70062 20.9995H0.346875V6.97922H4.70062V20.9995ZM2.52141 5.06672C1.12922 5.06672 0 3.91359 0 2.52141C9.96468e-09 1.85269 0.265647 1.21136 0.738503 0.738503C1.21136 0.265647 1.85269 0 2.52141 0C3.19012 0 3.83145 0.265647 4.30431 0.738503C4.77716 1.21136 5.04281 1.85269 5.04281 2.52141C5.04281 3.91359 3.91313 5.06672 2.52141 5.06672ZM20.9953 20.9995H16.6509V14.1745C16.6509 12.548 16.6181 10.462 14.3873 10.462C12.1237 10.462 11.7769 12.2292 11.7769 14.0573V20.9995H7.42781V6.97922H11.6034V8.89172H11.6644C12.2456 7.79016 13.6655 6.62766 15.7838 6.62766C20.19 6.62766 21 9.52922 21 13.298V20.9995H20.9953Z" 
                fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Linkedin);
